import { render, staticRenderFns } from "./tasksBuyingView.vue?vue&type=template&id=4613b2b4&"
import script from "./tasksBuyingView.vue?vue&type=script&lang=js&"
export * from "./tasksBuyingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports